@let hasQualificationDeletePermission =
  can(RoleAction.Delete, RolePermissionSubject.UserQualificationV2);
@let hasQualificationImportPermission =
  can(RoleAction.Create, RolePermissionSubject.UserQualificationV2);
@let hasQualificationEditPermission =
  can(RoleAction.Update, RolePermissionSubject.UserQualificationV2);
@let hasQualificationCreatePermission =
  can(RoleAction.Create, RolePermissionSubject.UserQualificationV2);
<wilson-page-frame-v2>
  <ng-container headerContent>
    <div class="d-flex gap-2">
      <wilson-search-filter
        [debounceTime]="200"
        (modelChange)="onSearchChange($event)"
      ></wilson-search-filter>
      <nz-badge [nzCount]="(numberOfAppliedFilters$ | async) || undefined">
        <button nz-button nzType="default" (click)="openDrawer()">
          <fa-icon [icon]="faFilter"></fa-icon>
        </button>
      </nz-badge>
    </div>
    <div
      class="d-flex flex-grow-1 justify-content-end border-end border-light gap-2 px-2"
    >
      <button
        nz-button
        nz-dropdown
        class="border-0"
        [nzDropdownMenu]="importMenu"
        [nzPlacement]="'bottomLeft'"
        [disabled]="!hasQualificationImportPermission"
        [nzDisabled]="!hasQualificationImportPermission"
        nzType="text"
        nz-tooltip
        [nzTooltipTitle]="'general.no_permissions' | translate"
        [nzTooltipTrigger]="!hasQualificationImportPermission ? 'hover' : null"
      >
        {{ 'page.qualifications.import' | translate }}
      </button>
      <nz-dropdown-menu #importMenu="nzDropdownMenu">
        <ul nz-menu>
          <li nz-menu-item>
            <wilson-csv-box-import-qualifications-v2
              [btnText]="'page.qualification.menu.import' | translate"
              [licenseKey]="csvBoxSheetLicenseKey"
              [hasChangePermissions]="hasQualificationImportPermission"
            ></wilson-csv-box-import-qualifications-v2>
          </li>
          <li nz-menu-item>
            @if (
              'portal-route-qualification-import-via-csvbox'
                | featureFlagPure
                | async
            ) {
              <wilson-csv-box-import-qualifications-v2
                [btnText]="'csvbox.qualification.routes.import' | translate"
                [licenseKey]="csvBoxRouteQualificationSheetLicenseKey"
                [hasChangePermissions]="hasQualificationImportPermission"
              ></wilson-csv-box-import-qualifications-v2>
            }
          </li>
        </ul>
      </nz-dropdown-menu>
      <wilson-qualification-export-dropdown></wilson-qualification-export-dropdown>
      @if (
        'portal-complementary-certificate-button' | featureFlagPure | async
      ) {
        <wilson-complementary-certificate-export-button></wilson-complementary-certificate-export-button>
      }
      @let selectionCount = selectionCount$ | async;
    </div>
    <div class="d-flex gap-2 ps-2">
      <button
        nz-button
        nzType="default"
        [disabled]="
          !hasQualificationDeletePermission ||
          !selectionCount ||
          selectionCount.count === 0
        "
        class="border-0"
        [ngClass]="{
          'delete-button':
            hasQualificationDeletePermission &&
            selectionCount &&
            selectionCount.count !== 0,
        }"
        (click)="deleteQualifications()"
        nz-tooltip
        [nzTooltipTitle]="'general.no_permissions' | translate"
        [nzTooltipTrigger]="!hasQualificationDeletePermission ? 'hover' : null"
      >
        {{ 'general.delete' | translate }}
        {{
          hasQualificationDeletePermission &&
          selectionCount &&
          selectionCount.count
            ? '(' + selectionCount.count + ')'
            : ''
        }}
      </button>
      <wilson-bulk-edit-qualifications-trigger></wilson-bulk-edit-qualifications-trigger>
      <wilson-bulk-create-qualifications-trigger></wilson-bulk-create-qualifications-trigger>
    </div>
  </ng-container>
  <ng-container mainContent>
    <wilson-qualifications-v2-list
      [statusFilter]="statusFilter"
      [categoryFilter]="categoryFilter"
      [orgUnitFilter]="orgUnitFilter"
      [userIdsFilter]="userIdsFilter"
      [userLabelsFilter]="userLabelsFilter"
      [searchFilter]="searchFilter"
      (selectedRowsChange)="onSelectedRowsChange($event)"
    ></wilson-qualifications-v2-list>
  </ng-container>
</wilson-page-frame-v2>

<wilson-qualification-filter-drawer
  [isDrawerVisible]="isDrawerVisible"
  (closeDrawer)="isDrawerVisible = false"
  (applyFilters)="onApplyFilters($event)"
></wilson-qualification-filter-drawer>

@if (hasQualificationEditPermission) {
  <wilson-bulk-edit-qualifications-drawer></wilson-bulk-edit-qualifications-drawer>
}
@if (hasQualificationCreatePermission) {
  <wilson-bulk-create-qualifications-drawer></wilson-bulk-create-qualifications-drawer>
}
